<div style="height: 54px !important;background-color: #ebebeb; width:728px" [dir]="textDir">   
    <div class="plabel" [dir]="textDir">{{myGrade?.name}}, {{myClass?.name}}</div>
</div>


<div class="white" *ngIf="mySubjectList?.length" [dir]="textDir">
    <ng-container *ngIf="viewType!=='edit'">
        <p class="marL10 marB20 dark-text">{{'Assign a teacher to each class' | translate }}</p>
    </ng-container>
    <div [ngClass]="viewType!=='edit' ? 'table-responsive': ''">
        <form [formGroup]="myForm">            
            <div formArrayName="subjectteacher">
                <div class="grey-text flexStart">
                    <div class="wid-150 brd pad5">{{'Subject'| translate }} </div>
                    <div class="sm-8 brd" *ngIf="viewType!=='edit'">{{'Teacher' |translate}}</div>
                    <ng-container *ngIf="viewType==='edit'">
                    <div class="wid-262 brd pad5 padL10">{{'Assigned Teacher' |translate}}</div>
                    <div class="wid-262 brd pad5 padL10">{{'Second Teacher (if applicable)' |translate}}</div>
                    </ng-container>
                </div>
                <div class="padT10">
                    <ng-container *ngFor="let ctrl of myForm.controls.subjectteacher.controls let i = index">
                        <ng-container *ngFor="let item of mySubjectList">
                            <div *ngIf="myForm?.controls?.subjectteacher.controls[i].get('subject').value?._id === item?._id" class="dark-text flexStart" [formGroupName]="i">
                                <div class="wid-150 brd pad5 line-hgt-15">
                                {{item?.name|ucfirst}}
                                </div>
                                <div class="sm-8 brd" *ngIf="viewType!=='edit'">                                
                                    <select id="selectTeacher" formControlName="teacher" style="width: 200px;height: 24px; border-radius: 3px; border: solid 1px #b2b3b3;" (change)="addToAssignmentList(item, $event.target.value)" [dir]="textDir">
                                        <option [value]='null'>{{'Select' |translate}}</option>
                                        <option *ngFor="let mteacher of myTeachers| orderBy : 'name'|unique: 'name'" [value]="mteacher?._id">{{mteacher?.name}}</option>
                                    </select>
                                </div>
                                <div class="wid-262 brd pad5 padL10" *ngIf="viewType==='edit'">
                                    <div class="absItem" [ngClass]="textDir">
                                        <ngx-select-dropdown formControlName="teacher" [multiple]="false" [options]="mTeachers[i]" [config]="teacherSelectConfig" (change)="removeSelectedFromSecondItem(i,$event)"></ngx-select-dropdown>
                                    </div>
                                
                                </div>
                                <div class="wid-262 brd pad5 padL10" *ngIf="viewType==='edit'">
                                    <div class="absItem" [ngClass]="textDir">
                                        <ngx-select-dropdown formControlName="teacher_two" [multiple]="false" [options]="mTeachers2[i]" [config]="teacherSelectConfig"></ngx-select-dropdown>
                                    </div>                                
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </form>
    </div>
</div>

